import { defineFetch } from 'resift';

const makeSetPassword = defineFetch({
  displayName: 'Set Password',
  make: personId => ({
    request: (password: string) => ({ http }) =>
      http({
        method: 'POST',
        route: `/people/${personId}/password`,
        data: {
          password,
        },
      }),
  }),
});

export default makeSetPassword;
